import React from 'react'
import { useDispatch } from 'react-redux'
import { deleteReference, getArticleById } from '../../../../entity/volumes/Volumes'
import { MdOutlineDelete } from 'react-icons/md'

const DeleteReference = ({ articleId, referenceId }) => {
  const dispatch = useDispatch()

  const deleteHandler = async () => {
    const confirmed = window.confirm('Do you want to delete this reference?')

    if (confirmed && articleId && referenceId) {
      await dispatch(deleteReference(referenceId))
      dispatch(getArticleById(articleId))
    } else {
      console.log('Delete action canceled')
    }
  }
  return (
    <MdOutlineDelete
      className='hover:cursor-pointer hover:scale-110 transition-all'
      onClick={deleteHandler}
    />
  )
}

export default DeleteReference
